import React from "react";
import Decimal from "./decimal";

export default function Currency(props) {
    return <Decimal value={props.value} format={props.format} prefix="£" />
}